import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";

const UploadImageForm: React.FC<{}> = () => {

    const { register, setValue, watch } = useFormContext();

    const [imageError, setImageError] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const image = watch('image');

    useEffect(() => {
        if (image?.[0]) {
            const { size, type } = image[0];

            if (!['image/png', 'image/jpeg', 'image/bmp', 'image/gif'].includes(type)) {
                setImageError('Plik musi byćw formacie: JPG, PNG, GIF lub BMP');
                setValue('image', '');
                setImagePreview('')
                return;
            }

            if (size > 550000) {
                setImageError('Zdjęcie musi być mniejsze niż 500KB');
                setValue('image', '');
                setImagePreview('')
                return;
            }

            setImageError('');
            setImagePreview(URL.createObjectURL(image[0]));

        }
    }, [image, setImageError, setValue, setImagePreview])

    return <div>
        <h4>Dodaj obrazek</h4>
        {imageError}
        <div>
            <input type="file" {...register('image')} /><br />
        </div>
        {imagePreview && <img src={imagePreview} alt='Podgląd' />}
    </div>
}

export default UploadImageForm;
